import { path, pathOr, pipe, contains, compose, length, flatten, filter, values } from 'ramda'
import { sectionFacetField, FILTER_ATTRIBUTES } from './filterConfig'

export const hasLocation = path(['configure', 'aroundLatLng'])
export const hasRefinements = path(['refinementList'])
export const hasQuery = path(['query'])

const filterContains = string => pipe(
  pathOr('', ['configure', 'filters']),
  contains(string)
)
const containsObjectId = filterContains('objectID')
export const containsOtherStates = filterContains('other_states')
export const containsOtherSections = filterContains('other_sections')

const refineLength = compose(
  length,
  flatten,
  filter(s => s !== ''),
  values
)

export const hasSearchState = (searchState) => ({
  location: hasLocation(searchState),
  locationUsState: containsOtherStates(searchState),
  otherSections: containsOtherSections(searchState),
  refinements: hasRefinements(searchState),
  query: hasQuery(searchState),
  objectIds: containsObjectId(searchState),
  searchState
})

export const sumFiltersCount = ({ searchState, ...searchConfig }) => Object.keys(searchConfig)
  .reduce((acc, key) => {
    const value = searchConfig[key]
    const isOtherSections = key === 'other_sections'

    if (value && !isOtherSections) {
      acc += key === 'refinements' ? refineLength(value) : 1
    }

    if (isOtherSections) {
      const checkedSections = getCheckedSections(searchState)
      if (checkedSections && checkedSections.length >= 1) {
        acc += checkedSections.length
      }
    }

    return acc
  }, 0)

export const getFiltersCount = pipe(
  hasSearchState,
  sumFiltersCount
)

const refinementListPath = state => {
  const refinementList = pathOr({}, ['refinementList'], state)
  const filterKey = FILTER_ATTRIBUTES.find(key => refinementList[key])

  if (filterKey) {
    const has = refinementList[filterKey]
    return Array.isArray(has) ? has[0] : null
  }
  return null
}

const queryPath = pathOr(null, ['query'])
const suggestionValuePath = pathOr(null, ['configure', 'value'])

export const getFilterText = (searchState = {}) => {
  const queryText = queryPath(searchState)
  const refinmentText = refinementListPath(searchState)
  const suggestionValueText = suggestionValuePath(searchState)
  const checkedSections = getCheckedSections(searchState)
  const sectionText = checkedSections && checkedSections.length && checkedSections[0]
  return queryText || refinmentText || suggestionValueText || sectionText
}

export const getCheckedSections = (searchState) => {
  const filters = pathOr('', ['configure', 'filters'], searchState)

  const idx = filters.indexOf(sectionFacetField)
  if (idx >= 0) {
    const sectionFilters = filters.slice(
      idx,
      filters.indexOf(')')
    )

    const sections = sectionFilters
      .split('OR')
      .map(s => s.trim())
      .map(s => s.split(':'))
      .map(s => s[1])
      .map(s => s.replace(/"/g, ''))

    return sections.filter((s, idx) => sections.indexOf(s) === idx)
  }
}
